import { ApiCode } from '@/const/api'
import { handleCatch } from '@/utils'
import axios from '@axios'

export default {
  namespaced: true,
  state: {
    rooms: [],
    total: 0,
    statuses: [],
  },
  getters: {
    rooms: state => state.rooms,
    total: state => state.total,
    statuses: state => state.statuses,
  },
  mutations: {
    SET_ROOMS: (state, rooms) => { state.rooms = rooms },
    SET_TOTAL: (state, total) => { state.total = total },
    SET_STATUS: (state, statuses) => { state.statuses = statuses },
  },

  actions: {

    async getRooms({ commit }, params) {
      try {
        const response = await axios.get('uni/rooms', { params })
        const { data } = response
        if (data.code === ApiCode.SUCCESS) {
          const { records } = data.data
          const { total } = data.data
          commit('SET_ROOMS', records)
          commit('SET_TOTAL', total)
        }
      } catch (e) {
        handleCatch(e)
      }
    },

    async createRoom({ commit }, dataObj) {
      try {
        const response = await axios.post('uni/rooms', dataObj)
        const { data } = response
        return data
      } catch (e) {
        handleCatch(e)
      }
    },

    async updateRoom({ commit }, dataObj) {
      try {
        const response = await axios.put('uni/rooms', dataObj)
        const { data } = response
        return data
      } catch (e) {
        handleCatch(e)
      }
    },

    async deleteRoom({ commit }, id) {
      try {
        const response = await axios.delete(`uni/rooms/${id}`)
        const { data } = response
        return data.code === ApiCode.SUCCESS
      } catch (e) {
        handleCatch(e)
      }
    },

  },
}
